import { createSingleEntityStore } from '@core/ngrx-legacy';
import { CompanyVerificationRequest } from '@core/tellent-company-verification-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<CompanyVerificationRequest>()('CompanyVerification');

export {
  actions as CompanyVerificationActions,
  selectors as CompanyVerificationSelectors,
  reducer as CompanyVerificationReducer,
  namespace as CompanyVerificationNamespace,
};
